<template>
	<div>
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item" @click="$router.push('/accountancy')">Contabilidad</li>
				<li class="breadcrumb-item active">Reportes regulatorios</li>
				<li class="breadcrumb-item active" aria-current="page">{{serie}} - {{reporte}}</li>
			</ol>
		</nav>
		<div class="container-fluid">
			<div class="row justify-content-md-center" style="margin-top:20px;">
				<div class="col-md-12">
					<vs-card>
						<template slot="header">
							<div class="row p-3 align-items-center border-bottom">
								<div class="col-4">
									<form class="form-group row">
										<div class="form-group col-6">
											<vs-select          
											label="Serie"            
											v-model.lazy="serie"
											class="w-full select-large"
											@change="autoSelectReport()">
												<vs-select-item
												v-for="(serie_item, serie_key) in series" 
												:key="serie_key"
												:value="serie_key"
												:text="serie_key"
												class="w-full"/>
											</vs-select>
										</div>
										<div class="form-group col-6">
											<vs-select          
											label="Reporte"            
											v-model.lazy="reporte"
											class="w-full select-large">
												<vs-select-item
												v-for="(reporte_item, reporte_key) in series[serie]" 
												:key="reporte_key" 
												:value="reporte_item"
												:text="reporte_item"
												class="w-full"/>
											</vs-select>
										</div>
									</form>
								</div>
								<div class="col-8 float-right">
									<nav>
										<div class="nav nav-tabs" id="nav-tab" role="tablist">
											<vs-button class="nav-link active" id="nav-envio-tab" data-bs-toggle="tab" data-bs-target="#nav-envio" type="button" role="tab" aria-controls="nav-envio" color="dark">Envio</vs-button>
											<vs-button class="nav-link" id="nav-correccion-tab" data-bs-toggle="tab" data-bs-target="#nav-correccion" type="button" role="tab" aria-controls="nav-correccion" color="dark">Correccion</vs-button>
											<vs-button class="nav-link" id="nav-reenvio-tab" data-bs-toggle="tab" data-bs-target="#nav-reenvio" type="button" role="tab" aria-controls="nav-reenvio" color="dark">Reenvio</vs-button>
											<vs-button class="nav-link" id="nav-follow-tab" data-bs-toggle="tab" data-bs-target="#nav-follow" type="button" role="tab" aria-controls="nav-follow" color="dark">Seguimiento</vs-button>
										</div>
									</nav>
								</div>
							</div>
						</template>
						
						<div class="border-bottom">
							<div class="tab-content" id="nav-tabContent">
								<div class="tab-pane show active" id="nav-envio" role="tabpanel"
									aria-labelledby="nav-envio-tab">
									<h2 class="text-primary mb-5"><strong>Envio</strong></h2>
								</div>
								<div class="tab-pane" id="nav-correccion" role="tabpanel"
									aria-labelledby="nav-correccion-tab">
									<h2 class="text-primary mb-5"><strong>Correcion</strong></h2>
									<div class="row">
										<div class="col-9">
											<form class="form-group">
												<div class="form-group">
													<vs-input label="Folio:" type="text" name="" class="full-width"
														placeholder="Ej.: 112-065509-20210202" v-model="folio"/>
												</div>
											</form>
										</div>
										<div class="col-3">
											<vs-button v-on:click="getFollow" color="black" size="large">Consultar corrección</vs-button>
										</div>
									</div>
								</div>
								<div class="tab-pane" id="nav-reenvio" role="tabpanel"
									aria-labelledby="nav-reenvio-tab">
									<h2 class="text-primary mb-5"><strong>Reenvio</strong></h2>
									<form class="form-group">
										<div class="form-group">
											<vs-input label="Folio:" type="text" name="" class="full-width"
												placeholder="Ej.: 112-065509-20210202" v-model="folio"/>
										</div>
									</form>
								</div>
								<div class="tab-pane" id="nav-follow" role="tabpanel"
									aria-labelledby="nav-follow-tab">
									<seguimiento :folioProp='folio'></seguimiento>
								</div>
							</div>
						</div>
						<div class="row border-bottom mt-5" v-if="submitType!='follow'">
							<div class="col-6">
								<div class="p-2">
									<h2 class="mb-5">Carga del archivo: CSV</h2>
									<form>
										<vs-input class="full-width" type="file" @change="toJSON"/>
									</form>
								</div>
								<div class="border-bottom p-2">
									<div id="jsoneditor" style="width: 100%; height: 300px;"></div>
								</div>
								<div class="border-bottom">
									<form class="form-group">
										<div class="form-group">
											<vs-input id="json" class=" d-none" type="text" name='json'/>
										</div>
										<vs-button v-on:click="sendJson">{{upperCaseSubmitType}}</vs-button>
									</form>
								</div>
							</div>
							<div class="col-6 py-2 px-0" v-if="submitType=='correcion'">
								<h2>Corrección:</h2><br>
								<div class="box-follow" id="highlightCorreccion">
								</div>
							</div>
							<div class="col-6">
								<div class="p-2">
									<h2>Respuesta:</h2><br>
									<p>{{response}}</p>
								</div>
							</div>
						</div>
					</vs-card>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import seguimiento from '@views/admin/reportes-regulatorios/seguimiento'
	import syntaxHighlight from "@mixins/syntaxHighlightJSON";

	export default {
		name: 'reportes-regulatorios-rx',
		props: [],
		components: {
			seguimiento,
		},
		mixins: [syntaxHighlight],
		created() {
			this.addLibraries();
		},
		mounted() {
			this.container = document.getElementById("jsoneditor");
			this.options = {};
			this.initInstance();
			this.submitType = 'envio';
		},
		data() {
			return {
				serie: 'R01',
				reporte: 112,
				series: {
					'R01': [
						112,
					],
					'R10': [
						10112,
						10122,
					],
					'R13': [
						13112,
						13162,
						13212,
						13222,
					],
				},
				container: null,
				options: {},
				editor: null,
				submitType: '',
				correccion: null,
				response: null,
				responseSITIAPI: null,
				folio: '',
			}
		},
		methods: {
			async getFollow() {
				const urlToSend = `/api/sitiapi/seguimiento/${this.folio}`;
				await this.requestGet(urlToSend, (jsonReponse) => this.correccion = jsonReponse).then(() => {
					document.getElementById("highlightCorreccion").innerHTML = this.highlightCorreccion;
				});
			},
			async requestGet(url, callback) {
				await axios.get(url)
					.then(response => (this.responseSeguimiento = response.data));
				callback(this.responseSeguimiento);
			},
			addLibraries() {
				let externalScript = document.createElement('script');
				externalScript.setAttribute('src',
					'https://cdnjs.cloudflare.com/ajax/libs/jsoneditor/9.5.6/jsoneditor.min.js');
				document.head.appendChild(externalScript);
				let externalStyle = document.createElement('link');
				externalStyle.setAttribute('href',
					'https://cdnjs.cloudflare.com/ajax/libs/jsoneditor/9.5.6/jsoneditor.min.css');
				externalStyle.setAttribute('rel', 'stylesheet');
				document.head.appendChild(externalStyle);
			},
			initInstance() {
				const self = this;
				var triggerTabList = [].slice.call(document.querySelectorAll('#nav-tab button'));
				triggerTabList.forEach(function (triggerEl) {
					var tabTrigger = new bootstrap.Tab(triggerEl);

					triggerEl.addEventListener('click', function (event) {
						event.preventDefault();
						tabTrigger.show();
						$('#nav-tabContent .tab-pane').hide();
						$(tabTrigger._element.dataset.bsTarget).show();

						switch (tabTrigger._element.dataset.bsTarget) {
							case '#nav-correccion':
								self.submitType = "correcion";
								break;
							case '#nav-reenvio':
								self.submitType = "reenvio";
								break;
							case '#nav-follow':
								self.submitType = "follow";
								break;
							case '#nav-envio':
							default:
								self.submitType = "envio";
								break;
						}
					});
				});
			},
			toJSON(event) {
				const self = this;
				const csvFile = event.target.files[0];

				const reader = new FileReader();
				reader.readAsText(csvFile);

				reader.onload = function (e) {
					const csvString = reader.result;

					const CSVToJSON = require('csvtojson');

					CSVToJSON({
							noheader: true,
							output: "csv"
						}).fromString(csvString)
						.then(jsonOutput => {
							// "claveInstitucion": "065509", // QA
							let jsonStr = `{
									"identificadorReporte": {
											"inicioPeriodo": "AAAAMMDD",
											"finPeriodo": "AAAAMMDD",
											"claveInstitucion": "065028",
											"reporte": "${self.reporte}"
									},
									"informacionFinanciera": []
							}`;
							let jsonObj = JSON.parse(jsonStr);

							let jsonHeaders = jsonOutput.shift();

							jsonObj['informacionFinanciera'] = [];
							for (const row of jsonOutput) {
								let rowToPush = {};
								for (const colIndex in row) {
									rowToPush[jsonHeaders[colIndex]] = row[colIndex];
								}
								jsonObj['informacionFinanciera'].push(rowToPush);
							}

							self.startEditor(jsonObj);
						}).catch(err => {
							console.log(err);
						});
				};
				reader.onerror = function (error) {
					console.log('Error: ', error);
				};

			},
			startEditor(jsonEditor) {
				if (this.editor === null) {
					this.editor = new JSONEditor(this.container, this.options);
				}
				this.editor.set(jsonEditor);
			},
			async sendJson() {
				let url = '';
				switch (this.submitType) {
					case 'envio':
						url = `/api/sitiapi/IFC/${this.serie}/${this.reporte}`;
						break;
					case 'correcion':
						url = `/api/sitiapi/IFC/${this.serie}/${this.reporte}/correccion/${this.folio}`;
						break;
					case 'reenvio':
						url = `/api/sitiapi/IFC/${this.serie}/${this.reporte}/reenvio/${this.folio}`;
						break;
				}
				let jsonToSend = this.editor.get();
				let jsonResponseBoth = await this.requestPost(url, jsonToSend, async (jsonReponse) => {
					if (typeof jsonReponse.folio !== 'undefined') {
						this.folio = jsonReponse.folio;
					}
					let jsonToStore = {
						'reportCategory': `${this.serie}`,
						'reportCode': `${this.reporte}`,
						'reportLabel': `${this.folio}`,
						'type': `${this.submitType}`,
						'jsonSent': jsonToSend,
						'jsonReceived': jsonReponse ?? {}
					};
					let jsonResponsePersist = await this.requestPostSITIAPI(
						'/api/sitiapi/regulatoryReports', jsonToStore);
					return [jsonReponse, jsonResponsePersist];
				});
			},
			async requestPost(url, data, callback) {
				await axios.post(url, data)
					.then(response => this.response = response.data);
				callback(this.response);
			},
			async requestPostSITIAPI(url, data) {
				await axios.post(url, data)
					.then(response => this.responseSITIAPI = response.data);
			},
			autoSelectReport() {
				this.reporte = null;
			},
		},
		computed: {
			upperCaseSubmitType() {
				return this.submitType == "correcion" ? `ENVIO ${this.submitType.toUpperCase()}` : this.submitType.toUpperCase();
			},
			highlightCorreccion() {
				return this.syntaxHighlight(this.correccion);
			}
		},
	}
</script>

<style lang="scss">
.box-follow {
	height: 400px;
	overflow: auto;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
	border-color: rgb(31, 116, 255);
}
.full-width {
	width: 100%;
}
</style>